<template>
  <div class="apply-page">
    <!-- 顶部导航栏 -->
    <div class="top-nav">
      <h1 class="title">申请加入联盟</h1>
    </div>
    <div class="txt">
      <img src="@/assets/success.png" alt="">
      <span>恭喜您</span>
      <span class="company">{{ displayName }}</span>
      <span>{{ successText }}</span>
    </div>
  </div>
</template>

<script>
import { normalizeMemberInfo, getApplyRoute } from '@/utils/memberStatus'

export default {
  name: 'wait',
  data() {
    return {
      companyName:'',
      memberType:''
    }
  },
  mounted () {
    this.$ajax.get('/api/user/current').then(res => {
      if (res.data.code !== 200) return
      const user = res.data.data || {}
      sessionStorage.setItem('userInfo', JSON.stringify(user))
      this.companyName = user.companyName
      const status = normalizeMemberInfo(user)
      this.memberType = status.memberType
      const target = getApplyRoute(user)
      if (target && target !== '/apply/success') {
        this.$router.replace(target)
      } else if (!status.hasApplied) {
        this.$router.replace('/apply/first')
      }
    })
  },
  computed: {
    displayName() {
      return this.memberType === 'PERSONAL' ? '个人用户' : this.companyName
    },
    successText() {
      return this.memberType === 'PERSONAL' ? '审核通过，已成为个人用户' : '已通过审核'
    }
  }
}
</script>

<style scoped>
.apply-page {
  background-color: #f8fafc;
  min-height: 100vh;
  padding-bottom: 80px;
  font-size: 12px;
}

/* 顶部导航 */
.top-nav {
  display: flex;
  align-items: center;
  padding: 16px 20px;
  background: #fff;
}
.back-btn {
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 12px;
}
.title {
  font-size: 18px;
  font-weight: 600;
  color: #1a1a1a;
  margin: 0 auto;
}
.txt{
  width: 100%;
  height: 80vh;
  font-size: 20px;
  font-weight: bold;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
}
img{
  width: 70px;
  height: 70px;
  margin-bottom: 20px;
}
.company{
  font-size: 24px;
  margin: 10px 0;
  max-width: 200px;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/menu/join/success.vue